export const getSearchResult = (searchText, data) => {
  return data.filter((item) =>
    Object.values(item)
      .join("")
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );
};

export function generateUUID() {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      // eslint-disable-next-line no-mixed-operators
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

// Simple XOR Encryption function
export function encrypt(text, key) {
  let result = "";
  for (let i = 0; i < text.length; i++) {
    result += String.fromCharCode(
      text.charCodeAt(i) ^ key.charCodeAt(i % key.length)
    );
  }
  return result;
}

// Decryption function (same as encryption for XOR)
export function decrypt(encryptedText, key) {
  return encrypt(encryptedText, key); // XOR decryption is the same as encryption
}

//add https:// if missing
export const NormalizeLink = (link) => {
  if (!link) {
    return link;
  }
  if (!link.startsWith("http://") && !link.startsWith("https://")) {
    return `https://${link}`; // Add https:// if missing
  }
  return link;
};
